import _Close from "@mui/icons-material/Close";
import React, { useEffect, useState } from 'react';
import { IconButton, Modal } from '@mui/material';
import { styled as muiStyled } from '@mui/styles';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import { VideoEmbedStaige } from 'app/components/videoEmbeeds/StaigeEmbed';
import { VideoEmbedYoutube } from 'app/components/videoEmbeeds/YoutubeEmbed';
import styled from 'styled-components';
import Device from 'app/services/Device';
import { EmbedSource } from 'app/components/videoEmbed/types/EmbedSource';
const Container = styled.div.withConfig({
  componentId: "sc-18n29rf-0"
})(["width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;"]);
const ButtonContainer = styled.div.withConfig({
  componentId: "sc-18n29rf-1"
})(["width:100%;height:", ";@media only screen and (orientation:portrait){padding-top:", ";height:", ";}"], SIZES['40'], SIZES['24'], SIZES['64']);
const VideoContainer = styled.div.withConfig({
  componentId: "sc-18n29rf-2"
})(["height:calc(100% - ", ");width:100%;margin:auto;display:flex;justify-content:center;align-items:center;@media only screen and (orientation:portrait){height:calc(100% - ", ");}"], SIZES['40'], SIZES['64']);
const VideoWrapper = styled.div.withConfig({
  componentId: "sc-18n29rf-3"
})(["width:100%;height:calc(100vw * 9 / 16);aspect-ratio:16/9;@media (min-aspect-ratio:16/9){width:auto;height:100%;}"]);
const StyledModal = muiStyled(Modal)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: COLORS.black
  }
}));
const EmbeddedVideo = _ref => {
  let {
    embedData,
    open,
    onClose
  } = _ref;
  const [ssrRender, setSsrRender] = useState(() => new Device().isServer());
  useEffect(() => {
    setSsrRender(false);
  }, []);
  const videoProvider = {
    [EmbedSource.Staige]: open => open ? /*#__PURE__*/React.createElement(VideoEmbedStaige, {
      isHydrationFinished: !ssrRender,
      id: embedData.uniqueId,
      source: embedData.source,
      videoUrl: embedData.url,
      matchSlug: embedData.matchSlug,
      playlistId: embedData.id
    }) : null,
    [EmbedSource.YouTube]: open => /*#__PURE__*/React.createElement(VideoEmbedYoutube, {
      data: embedData,
      open: open
    })
  };
  if (!Object.keys(videoProvider).includes(embedData.source)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledModal, {
    open: open,
    onClose: onClose,
    "data-sentry-element": "StyledModal",
    "data-sentry-component": "EmbeddedVideo",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      marginLeft: SIZES['24'],
      left: 0,
      top: 0
    },
    onClick: onClose,
    "data-sentry-element": "IconButton",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, /*#__PURE__*/React.createElement(_Close, {
    color: "icon-invert",
    "data-sentry-element": "Close",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }))), /*#__PURE__*/React.createElement(VideoContainer, {
    "data-sentry-element": "VideoContainer",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, /*#__PURE__*/React.createElement(VideoWrapper, {
    "data-sentry-element": "VideoWrapper",
    "data-sentry-source-file": "EmbeddedVideo.tsx"
  }, videoProvider[embedData.source](open)))));
};
export { EmbeddedVideo };